import { createContext } from "react";

const orderByContext = createContext();

export default orderByContext;
